import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  isAdmin,
  isAdminOrPartnerOrAssistant,
  isAdminOrPartnerOrAssistantOrManager,
} from "../functions/checkrole";
// import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { FaNewspaper, FaTools, FaUsers } from "react-icons/fa";
import { Drawer, DrawerHeader } from "./DrawerAndAppBar";
const faIconStyle = { fontSize: 28 };
const muiIconStyle = { fontSize: 30 };
// const ioIconStyle = { fontSize: 32 }
const linkPath = (title) => title.replace(/\s+/g, "").toLowerCase();

const getChildLinkTitles = (child) =>
  child.flatMap((item) => (typeof item === "string" ? [item] : item.children));

const nested = () =>
  [
    [
      isAdmin() && "Organizations",
      // 'Translations',
      isAdmin() && "Difficulty Group",
      isAdmin() && "Domain",
      // 'Award',
      // 'Countries',
      // 'Grades',
      // 'Topics',
      // 'Currencies',
      isAdmin() && "Task",
      // 'Task Moderation',
      isAdmin() && "Collection",
    ],
    ["Collections", "Tasks"],
    [
      "Users",
      // 'Administrators',
      // 'Country Partners',
      // 'Teacher Super Admins',
      // 'Role',
      // 'Add Role'
    ],
    ["Students", "Merge Student"],
    [
      isAdminOrPartnerOrAssistant() && "Competitions",
      "Schools",
      // isAdmin() && 'Pending Competition Partners',
      "Participants",
      isAdmin() && "Team Competitions",
      isAdmin() && "Certificate Templates",
      "Print Certificate",
      {
        title: "Task Translation",
        children: ["Assign Translation", "Translate", "Download Contest Paper"],
      },
      // 'Competition Sessions'
    ],
    ["Books", "Announcements", "Advertisements"],
    ["Competition Participation", "Competition Session Status"],
  ].map((n) => n.filter(Boolean));
const allBtns = () => [
  { title: "Dashboard", icon: <DashboardIcon style={muiIconStyle} /> },
  {
    title: "Setup",
    icon: <FaTools style={faIconStyle} />,
    child: nested()[0],
    openLinks: false,
  },
  //  {title:'Moderation' , icon:<GiCheckedShield style={faIconStyle}/>,child: nested()[1], openLinks: false },
  // isAdminOrPartner() && { title: 'Manage Users', icon: <FaUsers style={faIconStyle} />, child: nested()[1], openLinks: false },
  isAdminOrPartnerOrAssistantOrManager() && {
    title: "Users",
    icon: <FaUsers style={faIconStyle} />,
  },
  // { title: 'Manage Students', icon: <FaGraduationCap style={faIconStyle} />, child: nested()[2], openLinks: false },
  {
    title: "Manage Competitions",
    icon: <FaNewspaper style={faIconStyle} />,
    child: nested()[4],
    openLinks: false,
  },
  // { title: 'Administrations', icon: <FaDatabase style={faIconStyle} />, child: nested()[4], openLinks: false },
  // { title: 'Reports', icon: <IoIosDocument style={ioIconStyle} />, child: nested()[5], openLinks: false },
  // { title: 'Mail Templates', icon: <MailIcon style={muiIconStyle} /> },
  // { title: 'Settings', icon: <SettingsIcon style={muiIconStyle} /> }
];

function CollapsibleLink({
  title,
  icon,
  child,
  openLinks,
  open,
  openNested,
  headListItemStyle,
  listItemStyle,
  location,
}) {
  const [openSubmenus, setOpenSubmenus] = useState({});

  useEffect(() => {
    const path = location.pathname.slice(1);
    child.forEach((item) => {
      if (typeof item === "object" && item.children) {
        const active = item.children.some((s) => linkPath(s) === path);
        if (active) {
          setOpenSubmenus((prev) => ({ ...prev, [item.title]: true }));
        }
      }
    });
  }, [location.pathname, child]);

  const nestedGroupHeadStyle = (subChildren) => ({
    color: subChildren.some((s) => location.pathname.slice(1) === linkPath(s))
      ? "#454E6F"
      : "#FFF",
  });

  return (
    <>
      <ListItem button key={title} onClick={() => openNested(title)}>
        <ListItemIcon style={headListItemStyle(child)}>{icon}</ListItemIcon>
        <ListItemText primary={title} style={headListItemStyle(child)} />
        {openLinks ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openLinks && open} timeout="auto">
        {child.map((link) =>
          typeof link === "string" ? (
            <List component="div" disablePadding key={link}>
              <Link
                to={`/${linkPath(link)}`}
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  button
                  style={{ ...listItemStyle(link), paddingLeft: 80 }}
                >
                  <ListItemText primary={link} />
                </ListItem>
              </Link>
            </List>
          ) : (
            <List component="div" disablePadding key={link.title}>
              <ListItem
                button
                onClick={() =>
                  setOpenSubmenus((prev) => ({
                    ...prev,
                    [link.title]: !prev[link.title],
                  }))
                }
                style={{
                  ...nestedGroupHeadStyle(link.children),
                  paddingLeft: 80,
                }}
              >
                <ListItemText primary={link.title} />
                {openSubmenus[link.title] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={Boolean(openSubmenus[link.title]) && open}
                timeout="auto"
              >
                {link.children.map((sub) => (
                  <List component="div" disablePadding key={sub}>
                    <Link
                      to={`/${linkPath(sub)}`}
                      style={{ textDecoration: "none" }}
                    >
                      <ListItem
                        button
                        style={{ ...listItemStyle(sub), paddingLeft: 100 }}
                      >
                        <ListItemText primary={sub} />
                      </ListItem>
                    </Link>
                  </List>
                ))}
              </Collapse>
            </List>
          )
        )}
      </Collapse>
    </>
  );
}

export default function SideBar({
  open,
  toggleDrawer,
  hoverDrawer,
  unhoverDrawer,
}) {
  const user = useSelector((state) => state.user);
  const [btns, setBtns] = useState(allBtns());
  useEffect(() => setBtns(allBtns()), [user]);
  let location = useLocation();
  //Open one sub list from the drawer at a time(Will close other sub list if any is open at the moment)
  const openNested = (title) => {
    let newBtns = [...btns];
    newBtns
      .filter((b) => b.child !== undefined)
      .forEach((btn) => {
        if (btn.title === title) btn.openLinks = !btn.openLinks;
        else btn.openLinks = false;
      });
    setBtns(newBtns);
  };
  const headListItemStyle = (child) => ({
    color: getChildLinkTitles(child).some(
      (el) => location.pathname.slice(1) === linkPath(el)
    )
      ? "#454E6F"
      : "#FFF",
  });
  const listItemStyle = (link) => ({
    color: location.pathname.slice(1) === linkPath(link) ? "#454E6F" : "#FFF",
  });
  const NormalLink = ({ title, icon }) => (
    <Link
      to={`/${title.replace(/\s+/g, "").toLowerCase()}`}
      style={{ textDecoration: "none" }}
    >
      <ListItem button style={listItemStyle(title)}>
        <ListItemIcon style={listItemStyle(title)}>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
    </Link>
  );
  return (
    <>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={() => hoverDrawer()}
        onMouseLeave={() => unhoverDrawer()}
      >
        <DrawerHeader>
          <IconButton
            onClick={() => toggleDrawer(false)}
            style={{ color: "#FFF" }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader>
        <List>
          {btns.filter(Boolean).map(({ title, icon, child, openLinks }) => (
            <div key={title}>
              {child === undefined
                ? NormalLink({ title, icon })
                : child.length
                ? CollapsibleLink({
                    title,
                    icon,
                    child,
                    openLinks,
                    open,
                    openNested,
                    headListItemStyle,
                    listItemStyle,
                    location,
                  })
                : null}
            </div>
          ))}
        </List>
      </Drawer>
      <DrawerHeader />
    </>
  );
}
